<template>
  <div class="card">
    <div class="card-header">

      <div class="bolder-title"> Тональность отзывов
        <popper hover content="График изменения распределения отзывов по тональности">
          <i class="bi bi-info pointer"></i>
        </popper>
      </div>
    </div>
    <div class="card-body">
      <div class="graph-header">
        <div id="legend-container-1" class="legend">
          <ul class="resource-list r-flex">
            <li v-for="resource in resources">
              <div class="name">
                <div class="resource-checkbox">
                  <input type="checkbox" name="" :id="`tone-graph-${resource.id}`" v-model="resource.check">
                  <label :for="`tone-graph-${resource.id}`">
                    <span :style="{backgroundColor: resource.bcolor, borderColor: resource.bcolor}" class="check"><i
                        class="bi bi-check"></i></span>
                    {{ resource.name }}</label>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <ul class="nav nav-underline">
          <li v-for="interval in intervals" :class="'nav-item' + (interval.value === active_interval?' active':'')">
            <a href="" :class="'nav-link' + (interval.value === active_interval?' active':'')"
               @click.prevent="active_interval = interval.value">{{ interval.name }}</a>
          </li>

        </ul>
      </div>
      <div class="graph">
        <Bar v-if="datacollection"
             :options="chartOptions"
             :data="datacollection"
        />
      </div>
    </div>
  </div>

</template>

<script>
import {Bar} from 'vue-chartjs'
import {Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale} from 'chart.js'
import {ReviewApi} from "@/api/reviews";
import datesMixin from "@/mixins/filterDates";
import {convertPeriodToDateRange, externalTooltipHandler, handleChartClick} from "@/plugins/chartPlugin";

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

ChartJS.defaults.plugins.legend.display = false;

export default {
  name: 'ToneGraph',
  mixins: [datesMixin],
  components: {Bar},
  data() {
    return {
      data: {},
      active_interval: '',
      intervals: [
        {name: "1Д", value: "day"},
        {name: "1Н", value: "week"},
        {name: "1М", value: "month"},
        {name: "3М", value: "quarter"},
        {name: "6М", value: "half_year"},
        {name: "1Г", value: "year"},
      ],
      resources: this.$TONES,
    }
  },

  watch: {
    active_interval(value) {
      this.getData()
    }
  },

  mounted: function () {
    this.active_interval = "month";
  },
  computed: {
    datacollection() {
      let data = {
        labels: this.data.dates,
        datasets: []
      }
      this.resources.filter(x => x.check === true).forEach(resource => {
        data.datasets.push({
          label: resource.name,
          borderColor: resource.bcolor,
          borderWidth: 2,
          backgroundColor: resource.color,
          data: this.data[resource.param]
        })
      })
      return data;
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        aspectRatio: 1,
        onHover: (event, chartElement) => {
          event.native.target.style.cursor = chartElement.length ? 'pointer' : 'default';
        },
        onClick: handleChartClick(this.$router, (dataIndex, clickedLabel) => {
          const tone = this.$TONES.find(t => t.name === dataIndex);
          const {start, end } = convertPeriodToDateRange(this.active_interval, clickedLabel, this.$moment().format("YYYY"));
          return tone ? {tones: tone.id, date_from:start, date_to: end} : null;
        }),
        scales: {
          x:
              {
                stacked: true,
                grid: {
                  display: false
                },
                ticks: {
                  autoSkip: false,
                },
              },
          y:
              {
                stacked: true,
                grid: {
                  display: false
                },

              },

        },
        interaction: {
          mode: 'index',
          intersect: false,
        },

        plugins: {
          htmlLegend: {
            containerID: 'legend-container',
          },
          legend: {
            display: false,
          },
          tooltip: {
            enabled: false,
            position: 'nearest',
            external: externalTooltipHandler
          },
          datalabels: {
            formatter: function (value, context) {
              return '';
            }
          }
        }
      }
    },
  },


  methods: {
    getData() {
      ReviewApi.tone_graph(this.active_interval, this.date_from, this.date_to).then(response => {
        this.data = response
      })
    }
  }
}

</script>
<style scoped lang="scss">
.graph {
  height: 350px;
}
</style>

